import { useDispatch } from 'react-redux';

import { openFanModal } from 'features/FanDatabase/Slices/FanDatabaseSlice';
import { FanData, Modals } from '../Slices/types';

export const useTableClick = (modal: Modals, fanData: FanData) => {
	const dispatch = useDispatch();
	return () => dispatch(openFanModal({ openModal: modal, fanData }));
};
